import { ApiError } from '../../../services/api';

/**
 * Messages d'état d'un écran du module.
 *
 * Raison d'être : ne JAMAIS présenter un échec comme un vide. « Aucun barème
 * saisi » alors que le serveur a répondu 403 envoie l'utilisateur corriger un
 * problème qui n'existe pas. Le message doit dire la cause réelle et ce qu'il
 * y a à faire.
 */

/** L'appelant n'a pas de fiche salarié : cas prévu, message dédié. */
export function estSansFiche(err: unknown): boolean {
  if (!(err instanceof ApiError)) return false;
  const body = err.body as { code?: string } | null;
  return err.status === 403 && body?.code === 'ndf_sans_fiche';
}

export function MessageErreur({ erreur }: { erreur: unknown }) {
  if (estSansFiche(erreur)) {
    return (
      <p className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
        Votre compte n’a pas encore de fiche salarié : le module ne peut donc rien vous montrer.
        Demandez à un administrateur de créer votre fiche.
      </p>
    );
  }

  const message =
    erreur instanceof ApiError
      ? erreur.status === 403
        ? 'Vous n’avez pas les droits nécessaires pour consulter ces données.'
        : erreur.message
      : 'Les données n’ont pas pu être chargées. Vérifiez votre connexion et réessayez.';

  return (
    <p className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">{message}</p>
  );
}

/** Vide réel, à distinguer d'un échec. */
export function MessageVide({ children }: { children: React.ReactNode }) {
  return (
    <p className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">
      {children}
    </p>
  );
}
